// @flow

import React, { Component } from 'react';
import { NavLink } from 'react-router-dom';

import './EvomerTable.scss';

export default class Footer extends Component{
  render() {
    return (
      <section className="evomer-description">
        <div className="advice_container container row">
            <div className="advice-background">
              <p className="advice-title">
                Rada fachowca
              </p>
              <p className="advice-text text-basic">
                W warunkach zwiększonej wilgotności i obniżonej temperatury rekomendujemy przyklejanie płyt termoizolacyjnych za pomocą EOS Klej do płyt XPS.  Skróci to czas wysychania do 24 godzin. 
              </p>
            </div>
          </div>
        <div className="evomer-usage_container container row">
          <div className="col-12">
            <img src="/img/evomer-logo-grey.png" className="logo-grey"/>
              <div className="h3-red bold-header">
                Szybka powłoka zużycie
              </div>
              <div className="table-row">
                  <img src="/img/hydroizolacyjna.png" className="product-photo-table"/>
                <table className="properties-table">
                  <tr>
                    <td className="bold-text">Ilość warstw</td>
                    <td>2</td> 
                    <td>3</td>
                  </tr>
                  <tr>
                    <td className="bold-text">Zużycie kg/m2</td>
                    <td>2 x 0,35 kg/m2 = 0,7kg/m2</td> 
                    <td>2 x 0,35 kg/m2 = 1,05kg/m2</td>
                  </tr>
                  <tr>
                    <td className="bold-text">Przesiąkliwość powłoki</td>
                    <td>Nie przesiąka pod ciśnieniem 1000 mm/24h</td> 
                    <td>Nie przesiąka pod ciśnieniem 6000 mm/24h</td>
                  </tr>
                </table>
              </div>
          </div>
        </div>
      </section>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/EvomerTable/EvomerTable.js